import * as Sentry from '@sentry/react'
import { getEnv } from '@/lib/env'
import { languages } from '@/lib/i18n/settings'

// A DSN is always a URL — this also ignores unresolved CI placeholders
// (e.g. a literal "$(NEXT_PUBLIC_SENTRY_DSN)" when the pipeline variable is undefined)
const rawDsn = getEnv('NEXT_PUBLIC_SENTRY_DSN')
const dsn = rawDsn.startsWith('http') ? rawDsn : ''
// The Docker image is built once and deployed to every environment, so the
// build-time MODE is always "production" — prefer the runtime NODE_ENV.
const environment = getEnv('NODE_ENV', import.meta.env.MODE)

Sentry.init({
  dsn,
  environment,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/.*\.promotal\.com\/api/,
    /^https:\/\/.*\.medconnect\.com\/api/,
  ],
  // 100% in dev/staging, 20% in production
  tracesSampleRate: environment === 'production' ? 0.2 : 1.0,
  // Session replay: 10% of sessions, 100% when an error occurs
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Only enable if DSN is configured
  enabled: !!dsn,
})

// Tag events with the URL locale so errors can be segmented per language
const urlLang = window.location.pathname.split('/')[1]
if ((languages as readonly string[]).includes(urlLang)) {
  Sentry.setTag('locale', urlLang)
}
